import { IPrintMacro } from "../../core/printinterface/PrintMacros";

export type { IPrintParamMacro };

// calls the rendering of fields iterated by iterator
interface IPrintParamMacro extends IPrintMacro {
    param: string; // name of of parameter to print
}
